/**
 * Fetches all paginated data from getRightItems(page).
 * Returns the same resultSet structure, but with all data combined.
 */
async function fetchAllItems(getFromApi) {
  // Fetch the first page
  const firstResult = await getFromApi(1);
  const { total, limit, data: firstData } = firstResult;

  // Calculate number of pages
  const totalPages = Math.ceil(total / limit);

  if (totalPages <= 1) {
    return { ...firstResult, data: firstData }; // only one page
  }

  // Fetch remaining pages in parallel
  const remainingResults = await Promise.all(
    Array.from({ length: totalPages - 1 }, (_, i) => getFromApi(i + 2)),
  );

  // Merge all data
  const allData = [firstData, ...remainingResults.map(r => r.data)].flat();

  return {
    data: allData,
    total,
    page: 1,
    limit,
  };
}

export default fetchAllItems;
